// src/views/CompaniaRoute.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { useCuerpo } from "../context/CuerpoContext";
import { prepararCompania } from "../services/companiasTenant";
import CompaniaDesactivada from "./CompaniaDesactivada";
import CompaniaDinamica from "./CompaniaDinamica";

// Compatibilidad visual exacta de Huasco durante la migración.
import Compania1 from "./Compania1";
import Compania2 from "./Compania2";
import Compania3 from "./Compania3";
import Compania4 from "./Compania4";
import Compania5 from "./Compania5";



const LEGACY_COMPONENTS = {
  kf83mx: Compania1,
  zl29qp: Compania2,
  rd77lt: Compania3,
  vb52cz: Compania4,
  wn64dy: Compania5,
};

export default function CompaniaRoute({ configVisibilidad }) {
  const { slug } = useParams();
  const { cuerpoId, cargandoCuerpo } = useCuerpo();
  const [compania, setCompania] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let activo = true;

    async function cargar() {
      if (cargandoCuerpo) return;
      if (!cuerpoId || !slug) {
        if (activo) {
          setError("No se pudo determinar el Cuerpo o la Compañía.");
          setCargando(false);
        }
        return;
      }

      setCargando(true);
      setError("");

      try {
        const q = query(
          collection(db, "companias"),
          where("cuerpo_id", "==", cuerpoId)
        );
        const snap = await getDocs(q);

        const encontrada = snap.docs
          .map((d) => prepararCompania(d, cuerpoId))
          .find((c) => c.slugResuelto === String(slug).toLowerCase());

        if (!encontrada) {
          if (activo) {
            setCompania(null);
            setError("La compañía solicitada no existe en este Cuerpo.");
          }
          return;
        }

        if (activo) setCompania(encontrada);
      } catch (e) {
        console.error("Error resolviendo compañía:", e);
        if (activo) setError("No se pudo cargar la compañía.");
      } finally {
        if (activo) setCargando(false);
      }
    }

    cargar();
    return () => {
      activo = false;
    };
  }, [cuerpoId, cargandoCuerpo, slug]);

  if (cargando) {
    return <div style={{ padding: 24 }}>Cargando compañía...</div>;
  }

  if (error || !compania) {
    return (
      <div style={{ padding: 24 }}>
        <h2>Compañía no disponible</h2>
        <p>{error || "No se encontró la compañía."}</p>
      </div>
    );
  }

  if (compania.activo === false) {
    return <CompaniaDesactivada />;
  }

  // Visibilidad independiente por Cuerpo y por compañía.
  if (configVisibilidad?.companias?.[compania.slugResuelto] === false) {
    return <CompaniaDesactivada mensaje={configVisibilidad?.mensaje_desactivacion} />;
  }

  // Huasco conserva por ahora sus vistas exactas ya probadas.
  if (String(cuerpoId).toLowerCase() === "huasco") {
    const Legacy = LEGACY_COMPONENTS[compania.slugResuelto];
    if (Legacy) return <Legacy />;
  }

  return <CompaniaDinamica compania={compania} />;
}
